import React from 'react';
import {VariantProps} from '../interfaces';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@material-ui/core';

function VariantDetails(props: VariantProps) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        marginTop: '14px',
        padding: '0',
        '& .icon, & h4.property': {
          color: '#8a8a8a',
        },
        '& .MuiDivider-root': {
          margin: '24px 0',
          color: '#d8d8d8',
        },
        '& h4': {
          margin: 0,
          padding: '0 8px',
        },
      },
      item: {
        marginBottom: '24px',
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 500,
      },
      label: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 400,
        color: '#8A8A8A',
        marginRight: 'auto',
      },
      typographyCards: {
        fontSize: '16px',
        color: 'white',
        backgroundColor: '#4BCF90',
        paddingTop: '8px',
        paddingRight: '24px',
        paddingBottom: '8px',
        paddingLeft: '50px',
        marginLeft: '-40px',
      },
      cardContent: {
        paddingLeft: '14px',
      },
      card: {
        width: '100%',
        marginBottom: '14px',
        overflow: 'visible',
        padding: '14px',
      },
    })
  );

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container md={12} lg={12} xs={12}>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Typography className={classes.typographyCards}>
                اطلاعات تنوع کالا
              </Typography>
            }
          />
          <CardContent style={{paddingBottom: '0'}}>
            <Grid item xs={12} sm={12} lg={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{'شناسه کالا:'}</span>
                <span>{props.variant.productId}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{'شناسه تنوع کالا:'}</span>
                <span>{props.variant.id}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'فروشنده / تامین کننده:'}
                </span>

                <span>{props.variant.sellerName}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'شناسه فروشنده / تامین کننده:'}
                </span>

                <span>{props.variant.sellerId}</span>
              </div>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}

export default VariantDetails;
